const map = {
	"./AccountDetails.png": 5620,
	"./AuthorizedSignatory.png": 1480,
	"./AuthorizedSignatoryPan.png": 6051,
	"./BusinessCategory.png": 3011,
	"./BusinessIdProof.png": 1664,
	"./Done.png": 9629,
	"./EnterPAN.png": 4546,
	"./GstDetails.png": 1769,
	"./IdProof.png": 670,
	"./PersonalPan.png": 9784,
	"./VerifyPAN.png": 965,
	"./add_location.png": 2408
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9510;